'use client';

import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { logger } from '@/core/logger';

// Firebase configuration for Remote Config and Analytics
const firebaseConfig = {
	apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
	projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
	appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
	measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

class FirebaseService {
	private app: FirebaseApp | null = null;
	private initialized: boolean = false;

	private validateRequiredConfig(): void {
		const missing = [];
		if (!firebaseConfig.apiKey)
			missing.push('NEXT_PUBLIC_FIREBASE_API_KEY');
		if (!firebaseConfig.projectId)
			missing.push('NEXT_PUBLIC_FIREBASE_PROJECT_ID');
		if (!firebaseConfig.appId) missing.push('NEXT_PUBLIC_FIREBASE_APP_ID');
		if (!firebaseConfig.measurementId)
			missing.push('NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID');

		if (missing.length > 0) {
			throw new Error(
				`Missing required Firebase configuration values: ${missing.join(', ')}. ` +
					'Please set these environment variables to use Firebase services.'
			);
		}
	}

	async initialize(): Promise<FirebaseApp | null> {
		// Prevent re-initialization
		if (this.initialized) {
			return this.app;
		}

		// Check if running in browser
		if (typeof window === 'undefined') {
			return null;
		}

		try {
			// Validate required configuration
			this.validateRequiredConfig();

			// Initialize Firebase (only once)
			this.app =
				getApps().length === 0
					? initializeApp(firebaseConfig)
					: getApp();
			this.initialized = true;

			return this.app;
		} catch (error) {
			logger.error('Failed to initialize Firebase', error);
			return null;
		}
	}
}

export const firebaseService = new FirebaseService();
